

import { connect } from "react-redux";
import * as CropperActions from "../actions/cropperActions";
import * as ActionCreators from "../actions/actionCreators";
import Cropper from "../components/cropper/cropper";

const mapStateToProps = state => ({
    translations: state.translations
  });

const mapDispatchToProps = dispatch => ({
    displayModal: name => {
      dispatch(ActionCreators.displayModal(name));
    },
    initializeCrop: (Draggabilly, refs) => {
      dispatch(CropperActions.initializeCrop(Draggabilly, refs));
    },
    crop: (image, index, refs) => {
      dispatch(CropperActions.crop(image, index, refs));
    }
  });

export default connect(mapStateToProps, mapDispatchToProps)(Cropper);
